import { PartnerEshopSalesEntity, SalesEntity } from '../apiTypes';
import {
  mockPartnerEshopSalesEntities,
  mockPartnerSalesEntity,
  mockSalesEntities,
} from '../mocks/salesEntityMock';
import api from '../base';

const BASE_PATH = 'management/sales-entities';

export async function getAllPartnerEshopSalesEntities(
  signal?: AbortSignal,
): Promise<PartnerEshopSalesEntity[]> {
  const response = await api.get<PartnerEshopSalesEntity[]>(
    `${BASE_PATH}/partner-eshops`,
    {
      signal,
    },
  );
  return response.data;
}

api.mock
  .onGet(`${BASE_PATH}/partner-eshops`)
  .reply(200, mockPartnerEshopSalesEntities);

export async function getAllSalesEntities(
  signal?: AbortSignal,
): Promise<SalesEntity[]> {
  const response = await api.get<SalesEntity[]>(
    BASE_PATH,
    {
      signal,
    },
  );
  return response.data;
}

api.mock
  .onGet(BASE_PATH)
  .reply(200, mockSalesEntities);

export async function getSalesEntityForPartnerEshop(
  marketplaceCode: string,
  signal?: AbortSignal,
): Promise<SalesEntity> {
  const response = await api.get<SalesEntity>(
    `${BASE_PATH}/${marketplaceCode}`,
    {
      signal,
    },
  );
  return response.data;
}

api.mock
  .onGet(/\/management\/sales-entities\/.+/)
  .reply(200, mockPartnerSalesEntity);

export async function updateSalesEntityForPartnerEshop(
  marketplaceCode: string,
  salesEntityDto: SalesEntity,
  signal?: AbortSignal,
): Promise<void> {
  await api.put(
    `${BASE_PATH}/${marketplaceCode}`,
    salesEntityDto,
    {
      signal,
    },
  );
}

api.mock
  .onPut(/\/management\/sales-entities\/.+/)
  .reply(204);
